<table class="table table-condensed table-wrapper-box">
    <tbody>
        <tr>
            <td width="40%" class="text-center">
                <strong>Județ</strong>
            </td>
            <td class="text-left">{{ address.judet_denumire || 'N/A' }}</td>
        </tr>
        <tr>
            <td class="text-center">
                <strong>Oraș</strong>
            </td>
            <td class="text-left">{{ address.oras || 'N/A' }}</td>
        </tr>
        <tr>
            <td class="text-center">
                <strong>Sector</strong>
            </td>
            <td class="text-left">{{ address.sector || 'N/A' }}</td>
        </tr>
        <tr>
            <td class="text-center">
                <strong>Adresă</strong>
            </td>
            <td class="text-left" *ngIf="!address.adresa_text"> {{
                'str. ' + (address.strada || '-') +
                ', nr. ' + (address.numar || '-') +
                ', bl. ' + (address.bloc || '-') +
                ', sc. ' + (address.scara || '-') +
                ', et. ' + (address.etaj || '-') +
                ', ap. ' + (address.apartament || '-')
                }}
            </td>
            <td class="text-left" *ngIf="address.adresa_text"> {{
                address.adresa_text
                }}
            </td>
        </tr>
        <tr>
            <td class="text-center">
                <strong>Observații</strong>
            </td>
            <td class="text-left">{{ address.observatii || 'N/A' }}</td>
        </tr>
    </tbody>
</table>